import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Header from '@components/Header';
import HeaderBar from '@components/HeaderBar';
import Footer from '@components/Footer';
import PreLoading from '@components/PreLoading';
import Container from '@components/Container';

import CarouselShow from '@modules/Products/CarouselShow';
import BasicInfo from '@modules/Products/BasicInfo';
import ProductInfo from '@modules/Products/ProductInfo';
import Material from '@modules/Products/Material';
import Certificate from '@modules/Certificate';
import TrancSource from '@modules/TrancSource';
import Brand from '@modules/Brand';

import { fetch } from '@utils/fetch';
import { getQuery } from '@utils/tools';

const useStyles = createUseStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
  },
  main: {
    maxWidth: 768,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: '#ffffff',
    opacity: 0,
    visibility: 'hidden',
    margin: 'auto',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, .25)',
    overflow: 'hidden',
  },
  noVid: {
    flex: '1',
    height: '100%',
    fontSize: 16,
    color: '#000',
    lineHeight: '30px',
    minHeight: '500px',
    width: '80%',
    textAlign: 'center',
    margin: '0 auto',
  },
}), {
  name: 'HomePage'
})

const HomePage = props => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [locale, setLocale] = useState(i18n.language);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchData = language => {
    setLoading(true);
    const params = {
      types: [
        'sku',
        'bindsku_9d53', 
        'buinfo', 
        'customizedDisplayInfo', 
        'trackinfo',
        'dcp1',
        'dcp2',
        'dcp3',
        'dcp4'
      ],
      language,
    };

    fetch(params).then((data) => {
      setData(data);
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      console.log(err);
    });
  }

  useEffect(() => {
    if (locale) {
      fetchData(locale);
    }
  }, [locale])

  const createMainContainer = () => {
    const query = getQuery();
    if (!query.vid) {
      return (
        <Container 
          flex
          alignItems='center'
          justify='center'
          className={classes.noVid}
        >
          {t('miss_vid')}
        </Container>
      )
    }
    return (
      <>
        {(locale && data) && (
          <>
            <Header data={data} setLocale={setLocale} />

            <HeaderBar t={t} />
            <div className={classNames(classes.root)}>

              <CarouselShow data={data} />

              <BasicInfo 
                data={data} 
                language={locale}
                t={t}
              />

              <ProductInfo data={data} t={t} />

              <Material data={data} t={t} />

              <Certificate
                t={t}
                data={data} 
                language={locale}
              />

              <TrancSource
                t={t}
                data={data} 
                language={locale} 
              />

              <Brand data={data} t={t} />
            </div>
            <Footer data={data} t={t} />
          </>
        )}
      </>
    )
  }

  return (
    loading ? (<PreLoading />) : createMainContainer()
  )
}
export default HomePage;